/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { RrpCalculationType } from './RrpCalculationType';
import {
    RrpCalculationTypeFromJSON,
    RrpCalculationTypeFromJSONTyped,
    RrpCalculationTypeToJSON,
    RrpCalculationTypeToJSONTyped,
} from './RrpCalculationType';

/**
 * 
 * @export
 * @interface RrpCalculationTypeMapping
 */
export interface RrpCalculationTypeMapping {
    /**
     * 
     * @type {RrpCalculationType}
     * @memberof RrpCalculationTypeMapping
     */
    type: RrpCalculationType;
    /**
     * 
     * @type {string}
     * @memberof RrpCalculationTypeMapping
     */
    target: string | null;
}



/**
 * Check if a given object implements the RrpCalculationTypeMapping interface.
 */
export function instanceOfRrpCalculationTypeMapping(value: object): value is RrpCalculationTypeMapping {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function RrpCalculationTypeMappingFromJSON(json: any): RrpCalculationTypeMapping {
    return RrpCalculationTypeMappingFromJSONTyped(json, false);
}

export function RrpCalculationTypeMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): RrpCalculationTypeMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'type': RrpCalculationTypeFromJSON(json['type']),
        'target': json['target'],
    };
}

export function RrpCalculationTypeMappingToJSON(json: any): RrpCalculationTypeMapping {
    return RrpCalculationTypeMappingToJSONTyped(json, false);
}

export function RrpCalculationTypeMappingToJSONTyped(value?: RrpCalculationTypeMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': RrpCalculationTypeToJSON(value['type']),
        'target': value['target'],
    };
}

